const IconToggleOnSwitch = (): JSX.Element => {
  return (
    <>
      <path
        d="M0.666016 12C0.666016 8.13401 3.80002 5 7.66602 5H17.666C21.532 5 24.666 8.13401 24.666 12C24.666 15.866 21.532 19 17.666 19H7.66602C3.80002 19 0.666016 15.866 0.666016 12Z"
        fill="currentColor"
      />
      <path
        d="M12.666 12C12.666 9.23858 14.9046 7 17.666 7C20.4274 7 22.666 9.23858 22.666 12C22.666 14.7614 20.4274 17 17.666 17C14.9046 17 12.666 14.7614 12.666 12Z"
        fill="white"
      />
      <path
        d="M20.5023 10.1226C20.659 10.2861 20.7373 10.6132 20.5806 10.7767L17.2904 14.7828C17.212 14.8645 17.1337 14.9463 17.0554 14.9463C16.8987 15.0281 16.6637 15.0281 16.507 14.8645L14.7835 13.0659C14.6268 12.9024 14.6268 12.5753 14.7835 12.4118C14.9402 12.2483 15.2536 12.2483 15.4102 12.4118L16.8203 13.8017L19.7972 10.1226C19.9539 9.95912 20.2673 9.95912 20.5023 10.1226Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconToggleOnSwitch;
